export const PROPERTY_LISTING_BATCH_KEY = 'property-listing';
export const PRODUCT_DETAILS_ACCESSIBILITY_BATCH_KEY = 'product-details-accessibility-batch-key';
export const PRODUCT_DETAILS_EXPERIENCE_BATCH_KEY_BATCH_ONE = 'product-details-experience-batch-key-batch-one';